import type { CampaignRecord } from "@/hooks/use-campaigns";
import { useNavigate } from "react-router-dom";
import { CopyIcon } from "lucide-react";
import { ConfirmationDialog } from "./confirmation-dialog";

type CloneCampaignDialogProps = {
  campaign: CampaignRecord;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function CloneCampaignDialog({
  campaign,
  open,
  onOpenChange,
}: CloneCampaignDialogProps) {
  const navigate = useNavigate();

  return (
    <ConfirmationDialog
      open={open}
      onOpenChange={onOpenChange}
      title={<>Clone {campaign.name}?</>}
      description={
        <>
          This opens the campaign creation flow pre-filled with{" "}
          <span className="tw:text-primary tw:font-semibold">
            {campaign.name}
          </span>
          's details so you can review and launch a copy.
        </>
      }
      confirmIcon={<CopyIcon />}
      confirmLabel="Clone"
      onConfirm={() => {
        onOpenChange(false);
        navigate("/campaigns/new", {
          state: {
            cloneCampaignId: campaign.id,
          },
        });
      }}
    />
  );
}
